export const Selectors = {
  shortcuts: '.tx-ig-shortcuts'
};
